/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { closelightbox } from '../../util/Functions';
import { ModalStyle } from "../../util/Styles";
import { useHistory } from 'react-router-dom';
import { Close } from "@mui/icons-material";

const AlboQueryLanguaje = (props) => {
  const [zPos, setZPos] = useState(45)
  const history = useHistory();
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState({ aql: "" });
  const [error, setErrors] = useState({ aql: "" });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    let d = {
      aql: props.contentModal,
    };
    setDisabled(true);
    setForm(JSON.parse(JSON.stringify(d)));
  };

  const send = async () => {
    let user = JSON.parse(localStorage.session);
    props.changeLoader(true);
    setZPos(-1)

    let data = form;
    data["agent"] = user["uuid"];

    let response = await API.service( "alboQueryLanguaje", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (response.status === 200 && response.data.data.response === "OK") {
      let widg = response.data.data.widget;
      props.setWidgets(JSON.parse(JSON.stringify(widg)));
      props.updateNext("update");
      closelightbox();
    } else {
      props.setWidgets([]);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (field) {
      f[field] = e.target.value;
      if (!e.target.value) {
        er[field] = "Dato obligatorio";
      } else {
        er[field] = "";
      }
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };

  const validateForm = (f, err) => {
    if (f["aql"] && !err["aql"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle style={{marginBottom: "0"}} >
          <span>
            Ejecutar consulta aql
            <p id="subtitle_2">albo query languaje</p>
          </span>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent sx={{paddingTop: "5px !important"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                multiline minRows={2} onChange={changeValue.bind(this, "aql")} label="Comando" size="small" fullWidth error={error.aql !== ""} helperText={error.aql ? error.aql : ''} />
            </Grid>          
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Enviar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default AlboQueryLanguaje;
